export const isInternalStaff = (user) => {
  if (!user?.email) {
    return false;
  }
  const emailParts = user.email.split('@');
  if (emailParts.length !== 2) {
    return false;
  }
  // We'll consider anyone on the @inscribe.ai email domain as internal
  return emailParts[1] === 'inscribe.ai';
};
